import { useTranslation } from 'react-i18next';
import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import { Button } from '@framework/ui/atoms/Button';

type Props = {
  isOpen: boolean;
  onConfirm(): void;
  onClose(): void;
};

export const AIAssistantChatDeleteConfirmModal = ({ isOpen, onConfirm, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <GeneralModal
      isOpen={isOpen}
      onClose={onClose}
      shouldCloseOnOverlayClick={false}
      title={t('viewModel.aiChat.deleteConfirmTitle')}
      submitButton={
        <Button color="danger" onClick={onConfirm}>
          {t('common.action.delete')}
        </Button>
      }
      cancelButton={
        <Button color="secondary" onClick={onClose}>
          {t('common.action.cancel')}
        </Button>
      }
    >
      <div className="w-[400px] p-4">
        <p>{t('viewModel.aiChat.deleteConfirmDescription')}</p>
      </div>
    </GeneralModal>
  );
};
